<template>
  <div>
    <v-card class="UsuarioFornecedorCadastro__Dialog">
      <v-card-title>
        <span class="headline">
          {{ $t('title.selecione_tipo_fornecedor') }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item @click="selecionarTipoFornecedor(tipo)"
            v-for="(tipo, index) in tiposFornecedor"
            :key="index"
            ripple>
            <v-list-item-content>
              <v-list-item-title class="primary--text">{{tipo.label}}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary">arrow_forward</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="accent" text @click.native="cancelarCadastroFornecedor">{{ $t('label.cancelar') }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>

export default {
  data() {
    return {
      tiposFornecedor: [{
        label: this.$t('label.tipos_fornecedor.aprovador_autorizado'), value: 'APROVADOR_AUTORIZADO',
      },
      {
        label: this.$t('label.tipos_fornecedor.representante_legal'), value: 'REPRESENTANTE_LEGAL',
      }],
    };
  },
  methods: {
    cancelarCadastroFornecedor() {
      this.$emit('UsuarioFornecedorCadastroDialog__FecharModalCadastroUsuario');
    },
    selecionarTipoFornecedor(tipoFornecedor) {
      this.$emit('UsuarioFornecedorCadastroDialog__CadastrarNovoFornecedor', tipoFornecedor.value);
    },
  },
};
</script>

<style>
.UsuarioFornecedorCadastro__Dialog .headline {
  width: 100%;
  text-align: center;
}
</style>
